import { makeAutoObservable } from 'mobx'
import type { ReactNode } from 'react'

class GlobalLoaderService {
  isShow = false
  content?: ReactNode

  constructor() {
    makeAutoObservable(
      this,
      {
        content: false,
      },
      { autoBind: true },
    )
  }

  closeLoader() {
    this.isShow = false
  }

  openLoader(content?: ReactNode) {
    this.content = content
    this.isShow = true
  }
}

const globalLoaderService = new GlobalLoaderService()

export default globalLoaderService
